import React, { Component } from "react";
import * as Connection from "./../libs/connections";
import { Link } from "react-router-dom";
import { PropTypes } from "prop-types";

import SVGnumber from "./SVGnumber";
import TrackLineOrange from "../assets/icons-main/line-orange-home.png";

import "../styles/components/SliderOurCars.css";

export default class OurCarAvatars extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeElement: 0,
      error: false,
      componentTitle: "",
      elements: []
    };
  }

  async componentDidMount() {
    //   $(document).ready(function() {
    //     function changeLeftPaddingOurSliders() {
    //       if ($(".our-cars--header h4")[0]) {
    //         const fromLeft = $(".our-cars--header h4").offset().left;
    //         $(".our-cars-slider").css({ "padding-left": fromLeft + "px" });
    //       }
    //     }
    //     $(window).resize(function() {
    //       changeLeftPaddingOurSliders();
    //     });
    //     changeLeftPaddingOurSliders();
    //   });
    try {
      const response = await Connection.getAllCars(this.props.carCategory);
      this.setState({
        elements: response.slice(0, 6)
      });
    } catch (err) {
      this.setState({
        error: true
      });
    }
  }

  render() {
    const {
      paddingTop,
      paddingBottom,
      background,
      text,
      sectionNumber,
      elements: steps
    } = this.props;

    return (
      <div
        className={`our-cars ${background ? "background" : ""}`}
        style={{
          paddingTop: paddingTop + "px",
          paddingBottom: paddingBottom + "px"
        }}
      >
        <div className="our-cars--header container container-small">
          <div className="row">
            <div className="col-12">
              <h5>
                <span>{sectionNumber}</span>
              </h5>
            </div>
            <div className="col-12">
              <h4 dangerouslySetInnerHTML={{ __html: text }} />
            </div>
          </div>
        </div>
        <div className="rent-in-6-steps container">
          <div className="row">
            {steps.map((step, idx) => (
              <div key={step.title} className="single col-5 col-md-2">
                <SVGnumber animate={false} colorBorder="#000" version={++idx} />
                <p>{step.title}</p>
              </div>
            ))}
          </div>
        </div>
        <div
          className="container container-small"
          style={{ paddingBottom: "70px" }}
        >
          <div className="svg-wrapper-v2">
            <img
              alt=""
              className=""
              src={TrackLineOrange}
              style={{ width: "100%" }}
            />
          </div>
        </div>
        <div className="our-cars--button container container-small">
          <div className="row">
            <div className="col-12 button--inner">
              <Link
                className="btn-general btn-general--noBackground"
                to="/motoconcierge"
              >
                Poznaj motoconcierge
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

OurCarAvatars.propTypes = {
  paddingTop: PropTypes.number,
  text: PropTypes.string.isRequired,
  paddingBottom: PropTypes.number,
  sectionNumber: PropTypes.string.isRequired,
  carCategory: PropTypes.number,
  carId: PropTypes.number
};

OurCarAvatars.defaultProps = {
  paddingTop: 0,
  paddingBottom: 0
};
